import { AfterViewInit, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-exam-semester-data',
  templateUrl: './exam-semester-data.component.html',
  styleUrls: ['./exam-semester-data.component.scss']
})
export class ExamSemesterDataComponent implements OnInit {
  ExamSemForm: FormGroup;
  dialogRef: MatDialogRef<any>;
  submitpayload: any;
  SemArrayTable: [];
  SemArray: FormArray;
  submitButton = true;
  editButton = false;
  userPermission: any;
  utp: any;
  SemesterCreate = true;
  SemesterUpdate = true;
  SemesterDelete = true;
  @Output() prev = new EventEmitter<void>();
  examSemList: any;
  length: any;
  status: any;
  errmsg: any;
  semcodd
semNamee
  isErrorMessageDisplayed: boolean;
  constructor(private modalPopupService: ModalpopService,
    public umsService: UmsService,
    private fb: FormBuilder,   public router: Router,
    private route: ActivatedRoute, private spinner:NgxSpinnerService, ) { }

  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if (this.utp !== 'Super Admin' && this.utp !== 'Admin') {
      // this.isSuperAdmin= false;
      this.userPermission.forEach(element => {
        if (element.PageName == 'Exam-Semester' && element.PCreate == false) {
          this.SemesterCreate = false;
        }
        if (element.PageName == 'Exam-Semester' && element.PUpdate == false) {
          this.SemesterUpdate = false;
        }
        // if (element.PageName == 'Exam-Semester' && element.PDelete == false) {
        //   this.SemesterDelete = false;
        // }
      
       
      });
    }
    this.submitButton = true;
    this.editButton = false;   
    this.ExamSemForm = this.fb.group({
      // SeCode: new FormControl ('', [Validators.required, Validators.pattern('^[0-9]*$')]),
      // SeName: new FormControl ('', [Validators.required, Validators.pattern('^[0-9a-zA-Z]*$')]),     
      SemArray: new FormArray([]),    
    });
    this. getExamSem();
  }
  

  getSemArrayControls() {
    return (this.ExamSemForm.get('SemArray') as FormArray).controls;
  }

  getExamSem(){
    let i =0;
    const payload = {};
    payload['SeEmId'] = sessionStorage.getItem('EmId');
    this.umsService.getExamSem(payload).subscribe((res) => {
      this.length = res.data.length;
      if(payload['SeEmId'] != null && payload['SeEmId'] != "")
      {
        if(res.data.length > 0){
          this.submitButton = false;
          this.editButton = true;
          // this.prepopulation(res.data)
          this.SemArrayTable = res.data;
          // this.SemArray.clear();
          this.SemArrayTable.forEach(element => {
            this.addNewRowPrepopulate(element);
          });
        }
        else{
          this.submitButton = true;
        this.editButton = false;
        // this.SemArray.clear();
        this.addNewRow(i);
        }
      }
      else{
        this.submitButton = true;
        this.editButton = false;
        // this.SemArray.clear();
        this.addNewRow(i);
      }
      this.examSemList = res.data;
      
    },(ERROR: HttpErrorResponse) => {
    });
  }


  addNewRowPrepopulate(e){
    const creds = this.ExamSemForm.controls.SemArray as FormArray;
    creds.push(
      this.fb.group({
        SeCode: new FormControl (e.SeCode,[Validators.pattern('^[A-Za-z0-9,-]*$')]),
        SeName:new FormControl (e.SeName),
        SeEmId: new FormControl (parseInt(sessionStorage.getItem('EmId'))),
        SeSr: new FormControl (e.SeSr),
      })
    );
    
    
  }
  addNewRow(i) {
    const creds = this.ExamSemForm.controls.SemArray as FormArray;
    creds.push(
      this.fb.group({
        SeCode: new FormControl ('',[Validators.required,Validators.pattern('^[A-Za-z0-9,-]*$')]),
        SeName:new FormControl ('',Validators.required),
        SeEmId: new FormControl (parseInt(sessionStorage.getItem('EmId'))),
        SeSr: new FormControl(i),
      })
    );
  }
  addNewRow2(i) {
    const creds = this.ExamSemForm.controls.SemArray as FormArray;
    if(creds.invalid){
      creds.controls.forEach(element => {
        element.get('SeCode').markAsTouched();
        element.get('SeName').markAsTouched();
        // element.get('OpMax').markAsTouched();
  
      })
    }else
    {

    const creds = this.ExamSemForm.controls.SemArray as FormArray;
    creds.push(
      this.fb.group({
        SeCode: new FormControl ('',[Validators.required,Validators.pattern('^[A-Za-z0-9,-]*$')]),
        SeName:new FormControl ('',Validators.required,),
        SeEmId: new FormControl (parseInt(sessionStorage.getItem('EmId'))),
        SeSr: new FormControl(i+1),
      })
    );
  }
  }

  errorcheck1(i){
    return i.controls['SeCode'].touched && i.controls['SeCode'].errors?.pattern
  
 }
 errorcheck11(i){
  return i.controls['SeCode'].touched && i.controls['SeCode'].errors?.required

}
 errorcheck2(i){
  return i.controls['SeName'].touched && i.controls['SeName'].errors?.pattern

}

clickAdd(){
  const creds = this.ExamSemForm.controls.SemArray as FormArray;
  if (creds.invalid) {
    creds.controls.forEach(element => {
      // element.get('OpCode').markAsTouched();
      // element.get('OpMin').markAsTouched();
      // element.get('OpMax').markAsTouched();

    })
  }
  else{
    let i;
    this.addNewRow2(i);
  }
}

back() {
  this.prev.emit();
}


  update(){
    if (this.ExamSemForm.invalid) {
      this.ExamSemForm.get('SeCode').markAsTouched();
      this.ExamSemForm.get('SeName').markAsTouched();
      return;
    } 
    else {
      let isErrorMessageDisplayed = false;
      let successMessage = false;
      if(this.length == this.ExamSemForm.value.SemArray.length){
        // this.UpdateExamSem();
        this.submitpayload = this.ExamSemForm.value;
        let arr = [];
        arr = this.submitpayload.SemArray
        arr.forEach(element => {
          this.umsService.updateExamSem(element).subscribe(res => {
            if (res.status && !successMessage && !isErrorMessageDisplayed) {
              successMessage = true;
              let data = {};
              data['message'] = 'Updated Successfully'
              data['title'] = 'Information'
              data['icon'] = 'fas fa-check'
              this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
              
            } else if (!res.status && !isErrorMessageDisplayed && !successMessage) {
              isErrorMessageDisplayed = true;
              let data = {};
              data['message'] = res.message;
              data['title'] = 'Error';
              data['icon'] = 'fas fa-times';
              this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
            }
          },(ERROR: HttpErrorResponse) => {
            if (!isErrorMessageDisplayed && !successMessage) {
              isErrorMessageDisplayed = true;
              let data = {};
              data['message'] =ERROR.error.message;
              data['title'] = 'Error';
              data['icon'] = 'fas fa-times';
              this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
            }
            });
        });
      }
      let arr = [];
      arr = this.ExamSemForm.value.SemArray;
      arr.forEach((element,i) => {
        if(i<this.length){
          // this.UpdateExamSem2(element)
          this.umsService.updateExamSem(element).subscribe(res => {
            if (res.status && !successMessage && !isErrorMessageDisplayed) {
              successMessage = true;
              let data = {};
              data['message'] = 'Updated Successfully'
              data['title'] = 'Information'
              data['icon'] = 'fas fa-check'
              this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
              
            } else if (!res.status && !isErrorMessageDisplayed && !successMessage) {
              isErrorMessageDisplayed = true;
              let data = {};
              data['message'] = res.message;
              data['title'] = 'Error';
              data['icon'] = 'fas fa-times';
              this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
            }
          },(ERROR: HttpErrorResponse) => {
            if (!isErrorMessageDisplayed && !successMessage) {
              isErrorMessageDisplayed = true;
              let data = {};
              data['message'] =ERROR.error.message;
              data['title'] = 'Error';
              data['icon'] = 'fas fa-times';
              this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
            }
            });
          
        }else if(i>=this.length){
        //  this.ExamSem2(element)
        this.umsService.addExamSem(element).subscribe(res => {
          if (res.status && !successMessage && !isErrorMessageDisplayed) {
            successMessage = true;
            let data = {};
            data['message'] = 'Updated Successfully'
            data['title'] = 'Information'
            data['icon'] = 'fas fa-check'
            this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
            
          } else if (!res.status && !isErrorMessageDisplayed) {
            isErrorMessageDisplayed = true;
            let data = {};
            data['message'] = res.message;
            data['title'] = 'Error';
            data['icon'] = 'fas fa-times';
            this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          }
        },(ERROR: HttpErrorResponse) => {
          if (!isErrorMessageDisplayed) {
            // Display error message only once
            isErrorMessageDisplayed = true;
            // Handle error and display error message
            let data = {};
            data['message'] = ERROR.error.message;
            data['title'] = 'Error';
            data['icon'] = 'fas fa-times';
            this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          }
        });
          
        }
      });
      
    }
  }

  submit(){
    const creds = this.ExamSemForm.controls.SemArray as FormArray;
    if ( creds.invalid) {
      creds.controls.forEach(element => {
        element.get('SeCode').markAsTouched();
        element.get('SeName').markAsTouched();
        // element.get('OpMax').markAsTouched();
  
      })
      return;
    } else {
      this.ExamSem();
    }
  }

  ExamSem() {
    this.submitpayload = this.ExamSemForm.value;
    let iserror = false;
    let arr = [];
    arr = this.submitpayload.SemArray
    var bar = new Promise<void>((resolve, reject) => {
      arr.forEach((value, index, array) => {
        this.umsService.addExamSem(value).subscribe(res => {
          if (res.status == false) {
            iserror = true;
            this.errmsg = res.message;
          }
          if (index === array.length -1) resolve();
        }
        ,(ERROR: HttpErrorResponse) => {
          iserror = true;
          this.errmsg = ERROR.error.message;
          if (index === array.length -1) resolve();
        });
      });
  });
  
  bar.then(() => {
    if(iserror == false){
      let  data = {}
      data['message'] = "Submitted Successfully"
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    }else{
      let  data = {}
      data['message'] = "Subjects defined"
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.ngOnInit();
      arr = [];
      this.SemArray.clear();
    }
  });
    // arr.forEach(element => {
      // this.umsService.addExamSem(element).subscribe(res => {
      //   if (res.status == false) {
      //     iserror = true;
      //     this.errmsg = res.message;
      //   }
      // }
      // ,(ERROR: HttpErrorResponse) => {
      //   iserror = true;
      //   this.errmsg = ERROR.error.message;
      // });
    //   alert("kimoiujnmj"+iserror)
    // });

   
  }

  deletesemRow(index) {
    const creds = this.ExamSemForm.controls.SemArray as FormArray;
      creds.controls.forEach(element => {
      this.semcodd =  element.value['SeCode'];
      this.semNamee =  element.value['SeName'] ;
      })
    if (index !== 0 && this.semcodd == '' && this.semNamee == '') {
      (<FormArray>this.ExamSemForm.get("SemArray")).removeAt(index);
    }
    else {
      let data = {}
      data['message'] = "This Row Can Not Be Deleted"
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

    }

  }

}